import { useMediaQuery } from 'react-responsive';
import { breakpoints } from 'constants/themeConstants';
function useResponsive(breakpoint = 'md') {
  return useMediaQuery({ maxWidth: breakpoints[breakpoint] - 0.02 });
}

export default useResponsive;
